import * as React from "react";

/**
 * Tracks whether the app is currently in dark mode by observing the
 * `data-color-scheme` attribute that the theme provider sets on `<html>`.
 */
export function useIsDarkMode(): boolean {
  const [isDark, setIsDark] = React.useState(
    () => document.documentElement.getAttribute("data-color-scheme") === "dark",
  );

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(
        document.documentElement.getAttribute("data-color-scheme") === "dark",
      );
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-color-scheme"],
    });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
